export const dataHintAttribute = "data-hint";
export const dataStepAttribute = "data-step";
export const dataHintPositionAttribute = "data-hint-position";
export const dataTooltipClassAttribute = "data-tooltip-class";
export const dataHintAnimationAttribute = "data-hint-animation";
